<footer>
    <p><a href="#" (click)="openModal('privacy', 'Privacy Notice')">Privacy notice</a></p>
    <p><a href="#" (click)="openModal('terms', 'Terms & Conditions')">Terms & Conditions</a></p>
</footer>
